<template>
  <div>
    <div id="hero-and-body">
      <div id="page-body">
        <div
          class="fullwidth-section text-dark section1"
          style="background-color: #eaf1ff"
        >
          <div class="fullwidth-content">
            <div class="wrapper-medium">
              <div
                class="column-section clearfix spaced-normal col-align-center no-anim"
              >
                <div
                  class="column one-half col1 no-anim tallest"
                  style="text-align: center"
                >
                  <!-- min-height: 882px; -->
                  <div class="phone12 golden">
                    <div class="screenborder">
                      <div class="screen12">
                        <!-- <div class="iframe"><iframe class="loadframe" style="display: block;"
													src="https://namya.app"
													sandbox="allow-same-origin allow-scripts"></iframe></div> -->
                        <div class="iframe">
                          <v-card
                            color="#f3f3f3"
                            class="my-6 px-5 pb-5 rounded width"
                            style="margin: auto; cursor: default"
                            width="450"
                            elevation="4"
                          >
                            <v-card-title
                              style="
                                color: #00189b;
                                font-size: 24px;
                                font-weight: 500;
                                justify-content: center;
                                white-space: nowrap;
                              "
                              align="center"
                            >
                              {{ business_info.name }}
                            </v-card-title>
                            <!-- <v-card-text align="center">خوش آمدید</v-card-text> -->
                            <v-row class="padding_input">
                              <v-card-text
                                style="
                                  color: #00479b;
                                  white-space: wrap;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                  padding: 5px;
                                  justify-content: center;
                                  font-size: 20px;
                                  font-weight: 200;
                                "
                                class="d-flex mb-2 Blink"
                                align="center"
                                >برای اطلاع از اخبار و رویداد های
                                {{ business_info.name }} به ما
                                بپیوندید</v-card-text
                              >
                              <v-col
                                class=""
                                cols="12"
                                style="
                                  margin: auto;
                                  background-color: #00479b;
                                  border-radius: 5px;
                                  height: 100px;
                                "
                              >
                                <div class="d-flex">
                                  <p
                                    class="pa-1"
                                    style="
                                      border-radius: 5px;
                                      margin: auto;
                                      background-color: #fff;
                                      color: gray;
                                      font-weight: 200;
                                      font-size: 14px;
                                      justify-content: center;
                                    "
                                  >
                                    شماره موبایل :
                                  </p>
                                </div>
                                <v-text-field
                                  class="inputPrice"
                                  solo
                                  reverse
                                  dir="ltr"
                                  background-color="#00479b "
                                  align="center"
                                  type="text"
                                  pattern="\d*"
                                  :maxlength="max"
                                  v-model="display"
                                  ref="input"
                                  :rules="[rules.required, rules.PhoneNumber]"
                                  @change="change($event)"
                                  @input="change($event)"
                                  @keypress="filter($event)"
                                >
                                </v-text-field>
                              </v-col>
                            </v-row>

                            <v-row align="center" class="pt-16 padding">
                              <v-col
                                align="center"
                                v-for="item in items"
                                :key="item.id"
                                cols="4"
                              >
                                <v-btn
                                  class="btn-3"
                                  :ripple="true"
                                  :elevation="item.elevation"
                                  :fab="item.fab"
                                  :tile="item.tile"
                                  :text="item.text"
                                  style="font-size: 24px"
                                  :loading="item.id == 12 ? load : false"
                                  @mousedown="
                                    if ($event.type == 'mousedown') {
                                      [
                                        item.id == 11
                                          ? processButtonHold_start()
                                          : item.id == 12
                                          ? send()
                                          : '',
                                      ];
                                    }
                                    setNumber(item.value);
                                  "
                                  @mouseup="
                                    $event.preventDefault();
                                    [
                                      item.id == 11
                                        ? processButtonHold_end()
                                        : '',
                                    ];
                                  "
                                  @touchstart="
                                    if (
                                      $event.type == 'touchstart' &&
                                      $event.cancelable
                                    ) {
                                      [
                                        item.id == 11
                                          ? processButtonHold_start()
                                          : item.id == 12
                                          ? send()
                                          : '',
                                      ];
                                    }
                                  "
                                  @touchend="
                                    [item.id == 11 ? processButtonHold_end : '']
                                  "
                                  large
                                  :color="item.color"
                                  >{{ item.label }}
                                  <v-icon v-show="item.icon">{{
                                    item.icon
                                  }}</v-icon></v-btn
                                >
                              </v-col>
                            </v-row>
                          </v-card>
                          <v-snackbar
                            elevation="4"
                            rounded="pill"
                            v-model="snackbar"
                            :color="snackbarColor"
                            :timeout="3000"
                          >
                            {{ text }}
                          </v-snackbar>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <audio id="alarm">
      <source src="../../assets/audio/click_touch.wav" />
    </audio>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      operator: null,
      a: "",
      b: "",
      tot: 0,
      display: "",
      load: false,
      form: {
        mobile: "",
        link: this.$route.params.id,
      },
      ripple: true,
      loading: false,
      snackbar: false,
      snackbarColor: "default",
      text: "",
      state: false,
      clicked: false,
      max: 11,
      time: null,
      hold: false,
      business_info: [],
      items: [
        {
          id: 3,
          label: 3,
          value: 3,
          elevation: "8",
          icon: "",
          color: "primary darken-2",
          tile: false,
          fab: true,
          text: true,
        },
        {
          id: 2,
          label: 2,
          value: 2,
          elevation: "8",
          icon: "",
          color: "primary darken-2",
          tile: false,
          fab: true,
          text: true,
        },
        {
          id: 1,
          label: 1,
          value: 1,
          elevation: "8",
          icon: "",
          color: "primary darken-2",
          tile: false,
          fab: true,
          text: true,
        },
        {
          id: 6,
          label: 6,
          value: 6,
          elevation: "8",
          icon: "",
          color: "primary darken-2",
          tile: false,
          fab: true,
          text: true,
        },
        {
          id: 5,
          label: 5,
          value: 5,
          elevation: "8",
          icon: "",
          color: "primary darken-2",
          tile: false,
          fab: true,
          text: true,
        },
        {
          id: 4,
          label: 4,
          value: 4,
          elevation: "8",
          icon: "",
          color: "primary darken-2",
          tile: false,
          fab: true,
          text: true,
        },
        {
          id: 9,
          label: 9,
          value: 9,
          elevation: "8",
          icon: "",
          color: "primary darken-2",
          tile: false,
          fab: true,
          text: true,
        },
        {
          id: 8,
          label: 8,
          value: 8,
          elevation: "8",
          icon: "",
          color: "primary darken-2",
          tile: false,
          fab: true,
          text: true,
        },
        {
          id: 7,
          label: 7,
          value: 7,
          elevation: "8",
          icon: "",
          color: "primary darken-2",
          tile: false,
          fab: true,
          text: true,
        },
        {
          id: 12,
          label: "",
          value: "",
          elevation: "7",
          icon: "mdi-send",
          color: "primary darken-2",
          tile: true,
          fab: false,
        },
        {
          id: 10,
          label: 0,
          value: 0,
          elevation: "8",
          icon: "",
          color: "primary darken-2",
          tile: false,
          fab: true,
          text: true,
        },
        {
          id: 11,
          label: "",
          value: "",
          elevation: "0",
          icon: "mdi-close",
          color: "primary darken-2",
          tile: false,
          fab: false,
          text: true,
        },
        // {
        //   id: 13,
        //   label: "",
        //   value: "",
        //   icon: "mdi-close",
        //   color: "red",
        // },
      ],
      rules: {
        counter: (value) =>
          value.length <= 10 || "تعداد شماره بیشتر از حد مجاز",
        required: (value) =>
          !!value || "لطفا فیلد شماره همراه را تکمیل فرمایید",
        PhoneNumber: (value) =>
          new RegExp(
            /^[\u0660\u06F00][\u0669\u06F99][\u0660-\u0669\u06F0-\u06F9\d]{9}$/
          ).test(value) || "شماره‌ی تلفن همراه را به درستی وارد نمایید",
      },
    };
  },
  created() {
    this.GetData();
  },
  mounted() {
    this.$refs.input ? this.$refs.input.focus() : "";
  },
  methods: {
    log: console.log,
    setNumber(num) {
      if (this.operator === null && this.display.length < 11) {
        this.a = num;
        this.display += this.a;
        alarm.play();
      } else {
        if (num != "") {
          this.a = num;
          this.display += this.a;
          this.b = this.display.slice(0, this.display.length - 1);
          this.display = this.b;
          alarm.play();
        }
      }
    },
    // clear() {
    //   this.a = "";
    //   this.b = "";
    //   // this.tot = 0;
    //   this.display = "";
    //   this.operator = null;
    // },
    processButtonClick() {
      var del = 0;
      del = this.display.slice(0, this.display.length - 1);
      this.display = del;
      this.a = this.display;
      alarm.play();
    },

    processButtonHold_start(callback) {
      this.hold = true;
      this.time = setTimeout(() => {
        if (this.hold) {
          callback;
          var del = 0;
          let count = this.display;
          for (var i = 0; i < count.length; i++) {
            del = this.display.slice(0, this.display.length - 1);
            this.display = del;
            this.a = this.display;
          }
          alarm.play();
        }
      }, 600);
    },
    processButtonHold_end($event) {
      var del = 0;
      this.hold = false;
      clearTimeout(this.time);
      del = this.display.slice(0, this.display.length - 1);
      this.display = del;
      this.a = this.display;
      alarm.play();
      $event.preventDefault();
    },
    async send() {
      var self = this;
      self.form.mobile = self.display;
      this.load = true;
      let response = await self.axios
        .post("https://namya.ir/api/v1/business/ecard/send", self.form)
        .then((response) => {
          this.snackbar = true;
          this.snackbarColor = response.data.success ? "success" : "warning";
          this.text = response.data.success
            ? response.data.success
            : "ورود توسط کلمه عبور با خطا مواجه شد";

          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.load = false;
            this.display = "";
          }, 2000);
        })
        .catch((errors) => {
          this.snackbar = true;
          this.snackbarColor = "red";
          if (self.form.mobile == "") {
            this.text = "فیلد موبایل الزامی می باشد";
          }else if (errors.response.status == 429) {
            this.text = "تعداد دفعات ارسال کارت ویزیت بیش از حد مجاز می باشد";
          } else {
            this.text = "ارسال اطلاعات با خطا مواجه شد";
          }
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.load = false;
          }, 2000);
        });
    },
    async GetData() {
      var self = this;
      self.form.mobile = self.display;
      let response = await self.axios
        .get(
          "https://namya.ir/api/v1/ecard/" + self.$route.params.id + "/business"
        )
        .then((response) => {
          if (response.data.data != null) {
            this.business_info = response.data.data;
          } else {
            swal({
              title: "کسب و کار وجود ندارد",
              text: "لطفا دوباره تلاش کنید",
              icon: "error",
              button: "فهمیدم",
              closeOnClickOutside: false,
            }).then(function () {
              window.location = "/";
            });
          }
        })
        .catch((error) => {
          swal({
            title: "کسب و کار وجود ندارد",
            text: "لطفا دوباره تلاش کنید",
            icon: "error",
            button: "فهمیدم",
            closeOnClickOutside: false,
          }).then(function () {
            window.location = "/";
          });
        });
    },
    filter($event) {
      let expect = $event.target.value.toString() + $event.key.toString();
      if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
        $event.preventDefault();
      } else {
        return true;
      }
    },
    change($event) {
      const value = $event;
      if (String(this.display).length <= 11) {
        this.display = value;
      } else {
        let newnumber = this.display.slice(0, -1);
        this.display = newnumber;
      }
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="css" scoped>
* >>> .theme--light.v-input input,
.theme--light.v-input textarea {
  color: #ffffff !important;
}
* >>> .v-input .v-label {
  right: 0px !important;
  left: auto !important;
  position: absolute;
  color: #ffffff;
}
.v-application .primary,
.v-application .red,
.v-application .success {
  border-color: #000 !important;
}
@media only screen and (min-width: 920px) {
  .padding {
    padding: 0px 50px 0px 60px;
  }
  .padding_input {
    padding: 10px 30px 0 30px;
  }
  .phone12 {
    margin: 15px auto;
    padding: 4px;
    border-radius: 50px;
    display: inline-block;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25), 0 3px 15px rgba(0, 0, 0, 0.35);
    -webkit-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25),
      0 3px 15px rgba(0, 0, 0, 0.35);
    -moz-box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25),
      0 3px 15px rgba(0, 0, 0, 0.35);
    position: relative;
  }

  .phone12:after {
    content: "";
    position: absolute;
    left: -4px;
    top: 260px;
    width: 4px;
    height: 50px;
    background: #000;
    display: block;
    border-radius: 4px 0 0 4px;
  }

  .phone12:before {
    content: "";
    position: absolute;
    left: -4px;
    top: 200px;
    width: 4px;
    height: 50px;
    background: #000;
    display: block;
    border-radius: 4px 0 0 4px;
  }

  .phone12 .screenborder:before {
    content: "";
    position: absolute;
    right: -7px;
    top: 200px;
    width: 4px;
    height: 100px;
    background: #000;
    display: block;
    border-radius: 0 4px 4px 0;
  }

  .phone12.golden,
  .phone12.golden .screenborder {
    background: #000;
    background: -moz-linear-gradient(
      45deg,
      #000000 0%,
      #c19e67 20%,
      #b68d4c 20%,
      #2d0406 66%,
      #b68d4c 78%,
      #c19e67 78%,
      #c19e67 78%,
      #000000 100%
    );
    background: -webkit-linear-gradient(
      45deg,
      #000000 0%,
      #c19e67 20%,
      #b68d4c 20%,
      #2d0406 66%,
      #b68d4c 78%,
      #c19e67 78%,
      #c19e67 78%,
      #000000 100%
    );
    background: linear-gradient(
      45deg,
      #000000 0%,
      #c19e67 20%,
      #b68d4c 20%,
      #2d0406 66%,
      #b68d4c 78%,
      #c19e67 78%,
      #c19e67 78%,
      #000000 100%
    );
  }

  .phone12.rosegolden,
  .phone12.rosegolden .screenborder {
    background: #000;
    background: -moz-linear-gradient(
      45deg,
      #000000 0%,
      #f2abbf 20%,
      #ef94ac 20%,
      #990d3e 66%,
      #f2abbf 80%,
      #f2abbf 81%,
      #f78cb2 81%,
      #000000 100%
    );
    background: -webkit-linear-gradient(
      45deg,
      #000000 0%,
      #f2abbf 20%,
      #ef94ac 20%,
      #990d3e 66%,
      #f2abbf 80%,
      #f2abbf 81%,
      #f78cb2 81%,
      #000000 100%
    );
    background: linear-gradient(
      45deg,
      #000000 0%,
      #f2abbf 20%,
      #ef94ac 20%,
      #990d3e 66%,
      #f2abbf 80%,
      #f2abbf 81%,
      #f78cb2 81%,
      #000000 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#000000', endColorstr='#000000', GradientType=1);
  }

  .phone12.blue,
  .phone12.blue .screenborder {
    background: #000;
    background: -moz-linear-gradient(
      45deg,
      #000000 0%,
      #3d518c 20%,
      #a1bee2 20%,
      #0b497f 66%,
      #a1bee2 80%,
      #3d518c 80%,
      #000000 100%
    );
    background: -webkit-linear-gradient(
      45deg,
      #000000 0%,
      #3d518c 20%,
      #a1bee2 20%,
      #0b497f 66%,
      #a1bee2 80%,
      #3d518c 80%,
      #000000 100%
    );
    background: linear-gradient(
      45deg,
      #000000 0%,
      #3d518c 20%,
      #a1bee2 20%,
      #0b497f 66%,
      #a1bee2 80%,
      #3d518c 80%,
      #000000 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#000000', endColorstr='#000000', GradientType=1);
  }

  .phone12.red,
  .phone12.red .screenborder {
    background: #000;
    background: -moz-linear-gradient(
      45deg,
      #000000 0%,
      #f72727 20%,
      #efa0a0 23%,
      #c40000 53%,
      #930000 67%,
      #efa0a0 82%,
      #ef3232 82%,
      #000000 100%
    );
    background: -webkit-linear-gradient(
      45deg,
      #000000 0%,
      #f72727 20%,
      #efa0a0 23%,
      #c40000 53%,
      #930000 67%,
      #efa0a0 82%,
      #ef3232 82%,
      #000000 100%
    );
    background: linear-gradient(
      45deg,
      #000000 0%,
      #f72727 20%,
      #efa0a0 23%,
      #c40000 53%,
      #930000 67%,
      #efa0a0 82%,
      #ef3232 82%,
      #000000 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#000000', endColorstr='#000000', GradientType=1);
  }

  .phone12 .screenborder {
    width: auto;
    height: auto;
    padding: 4px;
    border-radius: 48px;
    display: block;
    border: rgba(255, 255, 255, 0.2) 0 solid;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.55),
      inset 1px 0 3px rgba(255, 255, 255, 0.55);
    -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.55),
      inset 1px 0 3px rgba(255, 255, 255, 0.55);
    -moz-box-shadow: 0 0 5px rgba(0, 0, 0, 0.55),
      inset 1px 0 3px rgba(255, 255, 255, 0.55);
    position: relative;
  }

  .phone12 .screenborder .screen12 {
    width: auto;
    display: block;
    height: auto;
    padding: 8px;
    border-radius: 44px;
    background-color: #000;
    position: relative;
  }

  /* .phone12 .screenborder .screen12 img {
  height: auto;
  width: 100%;
  border-radius: 38px;
  min-height: 812px;
  position: relative;
} */

  .phone12 .screenborder .screen12 .start-demo {
    background: rgba(255, 255, 255, 0.8);
    border-radius: 38px;
    position: absolute;
    bottom: 8px;
    left: 8px;
    height: auto;
    width: 375px;
    color: #000000 !important;
    z-index: 1;
    padding: 20px 30px 20px 30px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    display: flex;
    -webkit-display: flex;
    -moz-display: flex;
    flex-direction: column;
    -webkit-flex-direction: column;
    -moz-flex-direction: column;
    justify-content: center;
    -webkit-justify-content: center;
    -moz-justify-content: center;
    align-items: center;
    -webkit-align-items: center;
    -moz-align-items: center;
    text-align: center;
    -moz-backdrop-filter: saturate(110%) blur(5px);
    -webkit-backdrop-filter: saturate(110%) blur(5px);
    backdrop-filter: saturate(110%) blur(5px);
    box-shadow: 0 -5px 15px rgba(0, 0, 0, 0.15);
    -webkit-box-shadow: 0 -5px 15px rgba(0, 0, 0, 0.15);
    -moz-box-shadow: 0 -5px 15px rgba(0, 0, 0, 0.15);
  }

  .phone12 .screenborder .screen12 .start-demo .startdemo-btn,
  .phone12 .screenborder .screen12 .start-demo .startdemo-data-src {
    border-radius: 30px;
    padding: 8px 25px;
    line-height: 24px;
    font-size: 14px;
    text-align: center;
    color: #ffffff !important;
    border: 0;
    background-color: #000;
    box-shadow: 0 1px 3px rgb(0 0 0 / 15%), 0 3px 10px rgb(0 0 0 / 15%);
    -webkit-box-shadow: 0 1px 3px rgb(0 0 0 / 15%), 0 3px 10px rgb(0 0 0 / 15%);
    -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15),
      0 3px 10px rgba(0, 0, 0, 0.15);
    margin: 5px auto;
  }

  .phone12 .screenborder .screen12 iframe {
    display: none;
    width: 375px;
    border: 0;
    border-radius: 38px;
    height: 812px;
  }
}
@media only screen and (min-width: 700px) and (max-width: 870px) {
  .width {
    width: 100% !important;
  }
  .padding {
    padding: 0px 220px 0px 220px;
  }
  .padding_input {
    padding: 10px 30px 0 30px;
  }
}
@media only screen and (max-width: 700px) {
  .padding {
    padding: 0px 20px 0px 20px;
  }
  .padding_input {
    padding: 10px 30px 0 30px;
  }
}
.inputPrice >>> input[type="number"] {
  -moz-appearance: textfield;
}
.inputPrice >>> input::-webkit-outer-spin-button,
.inputPrice >>> input::-webkit-inner-spin-button {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
*
  >>> .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 0%), 0px 2px 2px 0px rgb(0 0 0 / 0%),
    0px 1px 5px 0px rgb(0 0 0 / 0%);
}
* >>> .v-text-field__details {
  display: none;
}
.rounded {
  border-radius: 15px !important;
}
* >>> .v-text-field__slot {
  font-size: 22px;
  font-weight: 800;
}
/* {
  position: absolute;
  height: 20px;
  width: 12px;
  background-color: #fff;
  opacity: 1;
  z-index: 5;
} */
/* .button {
  text-decoration: none;
  color: white;
  border-radius: 4px;
  margin-top: -10px;
  -moz-transition: all 0.15s ease-in-out;
  -o-transition: all 0.15s ease-in-out;
  -webkit-transition: all 0.15s ease-in-out;
  transition: all 0.15s ease-in-out;
  border-radius: 7px;
}
.button:active {
  /* margin-top: -5px;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
} */
.ripple {
  background-position: center;
  transition: background 0.8s !important;
}
.ripple:active {
  background-color: #6eb9f7 !important;
  background-size: 100%;
  transition: background 0s !important;
}
.v-application .red {
  background-color: #ff2b1b !important;
}
.v-application .success {
  background-color: #02c808 !important;
}
.v-application .primary {
  background-color: #008ac9 !important;
}

/* for frame */
/* phone */
::after ::before {
  box-sizing: content-box !important;
  color: white;
}

#menu nav#main-nav > ul > li .sub-menu .item-thumb {
  margin-top: 0;
}

#menu nav#main-nav > ul > li.megamenu4 > .sub-menu {
  width: 1024px;
}

.arrowdemo {
  position: relative;
  margin-top: 50px;
  text-align: center;
}

.position-relative {
  position: relative;
}

.arrowdemo img.arrowimg {
  width: 70px;
  transform: rotate(71deg);
  -ms-transform: rotate(71deg);
  -moz-transform: rotate(71deg);
}

.arrowdemo .left-part {
  width: 48%;
  text-align: right;
  display: inline-block;
  padding-right: 30px;
  border-right: 1px dashed #ddd;
  box-sizing: border-box;
  vertical-align: top;
}

.arrowdemo .right-part {
  width: 48%;
  text-align: left;
  display: inline-block;
  box-sizing: border-box;
  vertical-align: top;
}

.arrowdemo h5 {
  font-size: 16px;
  margin-top: 10px;
  font-weight: 500;
}

.arrowdemo p {
  margin-top: 0;
  font-size: 12px;
}

.arrowdemo img.scanme {
  position: relative;
  margin-top: 0;
  width: 95px;
}

.overlaybg {
  position: fixed;
  z-index: 99998;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  height: 100vh;
}

.phonex.detached {
  position: fixed;
  z-index: 99999;
  right: 0;
  top: 40px;
}

.text-center ul {
  display: inline-block;
}

.socialmedia-widget li a {
  line-height: 22px;
}

.socialmedia-widget li a::before {
  font-size: 22px;
}

.woo_main_title .main_title {
  display: block;
}

#header,
#footer {
  display: none;
}

body:not(.single-product) #header + #hero-and-body > #page-body:first-child {
  margin-top: calc(64px + 80px) !important;
}

body.maxframeloaded:not(.single-product)
  #header
  + #hero-and-body
  > #page-body:first-child {
  margin-top: 0 !important;
}

body #cookie-notice.cookie-notice-hidden {
  padding: 0;
}

.margin-top-200 {
  margin-top: -250px;
  position: relative;
  z-index: 3;
}

.margin-top-200 .isotope-item {
  border: 3px solid #fff;
  box-sizing: border-box;
}

p > a {
  vertical-align: middle !important;
}

.product .product-info .product_title {
  font-size: 36px;
  line-height: 46px;
}

.main-content.left-float {
  border-right: 1px solid #f3f3f3;
  padding-right: 20px;
}

#blog-single .meta-tags a {
  font-size: 1em;
  line-height: 1.3em;
  display: inline-block;
  padding: 5px 10px;
  border: 1px solid #ddd;
  margin: 3px 1px;
  border-radius: 25px;
}

.product .product-layout-modern .column-section {
  display: -webkit-flex;
  display: -ms-flex;
  display: -moz-flex;
  display: flex;
}

.product .product-layout-modern .column-section .column:nth-child(2) {
  -webkit-order: 2;
  order: 2;
}

.product .product-layout-modern .column-section .column.last-col {
  order: 1;
  -webkit-order: 1;
  float: left;
}

@media only screen and (min-width: 769px) {
  .product .product-layout-modern .product-info {
    margin: 200px 0 100px 0;
  }
}
.text-center {
  text-align: center;
}

.form-control {
  box-shadow: none !important;
}

.btn-3:active {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  transform: scale(1.2);
  -webkit-transition: transform 0.1s ease-in-out;
  -moz-transition: transform 0.1s ease-in-out;
  -ms-transition: transform 0.1s ease-in-out;
}
.btn-3:not(:active) {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  transform: scale(1);
}
* >>> button.elevation-8 span.v-btn__content {
  margin-top: 10px !important;
}
</style>
